import { mapZones } from './mapZones';
export function updateZones(spectrum) {
    spectrum.zones.values = mapZones(spectrum.zones.values, spectrum, {
        checkIsExisting: false,
        shiftTarget: 'current',
    });
}
//# sourceMappingURL=updateZones.js.map